import { ChevronLeft } from 'lucide-react'
import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface MainTopBarProps {
  leftSide?: ReactNode
  rightSide?: ReactNode
  className?: string
  hasBackButton?: boolean
  handleClickBackButton?: () => void
}

const MainTopBar = ({
  leftSide,
  rightSide,
  className,
  hasBackButton = false,
  handleClickBackButton
}: MainTopBarProps) => {
  return (
    <div
      className={twMerge(
        'py-4 px-4 gap-3 flex flex-row justify-between items-center sticky top-0 z-10 bg-gradient-to-r from-amber-400 to-yellow-300 h-[60px]',
        className
      )}
    >
      <div className='flex flex-row gap-1 w-full'>
        {hasBackButton && (
          <button onClick={handleClickBackButton}>
            <ChevronLeft size={20} className='text-text-header' />
          </button>
        )}
        {leftSide && leftSide}
      </div>
      <div className='flex flex-row gap-1'>{rightSide && rightSide}</div>
    </div>
  )
}

export default MainTopBar
